<section class="classic-landing">

  <!-- Product switch shared with /discover (dev only): "render" is this landing, "references" the new one. -->
  <app-discover-topbar *ngIf="showDiscoverTopbar" [active]="'render'" (accountClicked)="onDiscoverAccountClick()"></app-discover-topbar>

  <!-- Hero Section -->
  <div class="hero-section">
    <!-- Mobile: GSAP-controlled title -->
    <h1 class="hero-title hero-title--mobile">Stop Rendering.<br>Start Showcasing.</h1>

    <div class="hero-content">
      <!-- Desktop: static title -->
      <h1 class="hero-title hero-title--desktop">Stop Rendering.<br>Start Showcasing.</h1>
      <a class="hero-media__caption mobile_caption" [ngClass]="heroMediaCaptionClass" [href]="heroMediaCaptionUrl" target="_blank"
        rel="noopener noreferrer">
        {{ heroMediaCaption }}
      </a>
      <p class="hero-description">
        Upload your models once, and we automatically generate cinematic 360 renders optimized for horizontal and vertical aspect ratios. Keep your portfolio polished and ready for studios, recruiters, and clients at a moment's notice.
      </p>
      <p class="hero-description">
        Whether you're a character artist, environment artist, architect, hard‑surface modeler, or 3D generalist, 3DWay is designed for you. <span class="hero-formats">Supported Formats: FBX & USDZ.</span>
      </p>
      <p class="watch">
        <a class="watch-link" (click)="openYoutubeVideo()">
          <span class="watch__label watch__label--desktop">Watch the film</span>
          <span class="watch__label watch__label--mobile">Watch the Film</span>
        </a>
        <span class="watch__divider" aria-hidden="true">·</span>
        <a
          class="watch-link watch-link--secondary"
          href="https://www.3dway.io/collection/AdxGxKyL6pDWQ0R2vt0k4e"
          target="_blank"
          rel="noopener noreferrer">
          <span>View Live Deliverables by 3D Artists</span>
        </a>
      </p>
    </div>

    <div class="hero-media">
      <div class="media-container">
        <!-- Desktop View -->
        <div class="desktop-view">
          <img src="assets/images/new-landing/device-imac-only-display.svg" alt="monitor frame" class="monitor-frame">
          <video #heroMonitorVideo loop muted playsinline preload="auto" class="monitor-video video1">
            <source type="video/mp4" [src]="landingMediaBaseUrl + '/_landing/first_video_web.mp4'">
          </video>
                <a class="hero-media__caption" [ngClass]="heroMediaCaptionClass" [href]="heroMediaCaptionUrl" target="_blank"
                  rel="noopener noreferrer">
                  {{ heroMediaCaption }}
                </a>
        </div>

        <!-- Mobile View -->
        <div class="mobile-view">
          <div class="phone-container">
            <img src="assets/images/new-landing/device-phone.svg" alt="Phone" class="phone-frame">
            <video #heroMobileVideo loop muted playsinline preload="auto" class="phone-media first-screen-phone-video">
              <source type="video/mp4" [src]="landingMediaBaseUrl + '/_landing/first_video_app.mp4'">
            </video>
          </div>
        </div>
      </div>
    </div>

    <app-scroll-cue
      [scrollTarget]="showWorkSection"
      [switchTarget]="showWorkSection"
      [scrollContainer]="scrollContainer"
      ariaLabel="Scroll to the next section">
    </app-scroll-cue>
  </div>

  <!-- Features Section -->
  <div class="features-section" id="features" #featuresSection>
    <h2 class="section-title section-title--desktop">The Secure Delivery Platform for 3D Freelancers.</h2>
    <h2 class="section-title section-title--mobile">The Secure Delivery Platform for 3D Freelancers.</h2>
    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-icon">
            <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M34.7894 22.6165L39.7785 17.3803C40.9214 16.1807 40.8755 14.2818 39.676 13.1389L37.504 11.0694C36.3045 9.92652 34.4055 9.97242 33.2626 11.172L28.2735 16.4082M34.7894 22.6165L9.65958 48.9915C7.94521 50.7908 5.0968 50.8596 3.29748 49.1453C1.49817 47.4309 1.42931 44.5825 3.14368 42.7832L28.2735 16.4082M34.7894 22.6165L28.2735 16.4082"
                stroke="white" stroke-width="3" />
              <rect x="48" y="15" width="4" height="4" rx="1" fill="white" />
              <path
                d="M48 7V4.41421C48 3.52331 46.9229 3.07714 46.2929 3.70711L43.7071 6.29289C43.0771 6.92286 43.5233 8 44.4142 8H47C47.5523 8 48 7.55228 48 7Z"
                stroke="white" stroke-width="3" />
              <rect x="32" width="4" height="4" rx="1" fill="white" />
              <path d="M43.2857 24V33M48 28.6957H39" stroke="white" stroke-width="3" stroke-linecap="round" />
              <path d="M21.2857 3V12M26 7.69565H17" stroke="white" stroke-width="3" stroke-linecap="round" />
            </svg>

        </div>
        <h3 class="feature-title">Auto-Studio Setup.</h3>
        <p class="feature-description">
          Drop in your model. Our engine automatically centers, scales to fit the screen, and applies cinematic lighting. Perfect composition, every time.
        </p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M41.5 48.6094C41.4998 51.0342 39.5342 52.9998 37.1094 53H15.8906C13.4658 52.9998 11.5002 51.0342 11.5 48.6094V4.39062C11.5002 1.96582 13.4658 0.000153178 15.8906 0H37.1094C39.5342 0.000153841 41.4998 1.96582 41.5 4.39062V48.6094ZM32.9502 3.29102C32.9501 4.3855 32.0623 5.27246 30.9678 5.27246H22.0322C20.9377 5.27246 20.0499 4.3855 20.0498 3.29102V3H15.8906C15.1227 3.00015 14.5002 3.62267 14.5 4.39062V48.6094C14.5002 49.3773 15.1227 49.9998 15.8906 50H37.1094C37.8773 49.9998 38.4998 49.3773 38.5 48.6094V4.39062C38.4998 3.62267 37.8773 3.00015 37.1094 3H32.9502V3.29102Z"
              fill="white" />
            <rect x="24.5977" y="44.9053" width="4.0027" height="1.99565" rx="0.963636" fill="white" />
          </svg>
        </div>
        <h3 class="feature-title">Client-Ready on Any Device.</h3>
        <p class="feature-description">
          Recruiters and clients review portfolios on the go. We ensure your scene loads instantly on phone, helping you make the perfect first impression anywhere.
        </p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M25.2189 0.395241C26.0132 -0.132524 27.0316 -0.128343 27.8215 0.387371L27.9874 0.505416L28.4154 0.829057C30.6137 2.439 32.6319 3.92004 35.6397 5.15935C38.8237 6.47121 41.8929 7.47069 43.7525 8.0367C45.4 8.53814 46.6438 10.0338 46.7478 11.8761C46.9482 15.4261 47.2542 23.2845 46.6182 30.9197C46.3956 33.8299 45.1104 36.5558 43.3912 38.9753C41.6671 41.4016 39.4435 43.6102 37.2022 45.5052C32.7206 49.2945 29.0068 51.9649 27.6079 52.7256C26.903 53.109 26.0797 53.0845 25.4029 52.6902C24.0826 51.9209 18.8493 49.3369 14.8297 45.5839C10.8666 41.8837 6.81127 36.771 6.38133 30.9158C5.75257 22.352 6.04529 15.053 6.24691 11.76C6.3551 9.99314 7.51625 8.55907 9.06398 8.0121C12.4009 6.83279 20.6461 4.01697 25.053 0.516237L25.2189 0.395241ZM26.5297 3.14963C21.6842 6.87148 13.2615 9.72255 10.0125 10.8708C9.50865 11.0488 9.19835 11.4845 9.16979 11.9509C8.97336 15.1593 8.6862 22.3091 9.30135 30.6876C9.64175 35.3229 12.9485 39.7521 16.7945 43.343C20.3206 46.6353 25.0492 48.9905 26.5469 49.8827C28.1677 48.9839 31.3688 46.5307 35.3461 43.1679C37.4756 41.3674 39.501 39.3403 41.0298 37.1889C42.5634 35.0307 43.5344 32.8358 43.6991 30.6827L43.7 30.6718C44.3194 23.2487 44.0217 15.5531 43.824 12.0512C43.7958 11.5539 43.455 11.0973 42.924 10.9357C41.0156 10.3548 37.8518 9.32509 34.5529 7.96587C31.408 6.67003 29.0442 5.03407 26.5297 3.14963Z"
              fill="white" />
            <path
              d="M34 18.6667H32.75V16.1905C32.75 12.7733 29.95 10 26.5 10C23.05 10 20.25 12.7733 20.25 16.1905V18.6667H19C17.625 18.6667 16.5 19.781 16.5 21.1429V33.5238C16.5 34.8857 17.625 36 19 36H34C35.375 36 36.5 34.8857 36.5 33.5238V21.1429C36.5 19.781 35.375 18.6667 34 18.6667ZM22.75 16.1905C22.75 14.1352 24.425 12.4762 26.5 12.4762C28.575 12.4762 30.25 14.1352 30.25 16.1905V18.6667H22.75V16.1905ZM34 33.5238H19V21.1429H34V33.5238Z"
              fill="white" />
          </svg>

        </div>
        <h3 class="feature-title">Pixels Streamed. Geometry Locked.</h3>
        <p class="feature-description">
          We stream a video feed, not the 3D scene. Your source geometry and topology never leave our secure vault, so they can never be ripped or stolen.
        </p>
      </div>
    </div>
  </div>

  <section class="show-work-section" #showWorkSection>
    <div class="show-work-media-glow show-work-media-glow--left" aria-hidden="true"></div>
    <div class="show-work-media-glow show-work-media-glow--right" aria-hidden="true"></div>
    <div class="show-work-header">
      <h2 class="show-work-title">Show the Work.<br>Keep the Asset.</h2>
      <p class="show-work-subtitle">
        The safest way to send 3D work for client review. Stream a high-fidelity preview to approve the design,
        without ever exposing your source files until you get paid.
      </p>
    </div>

    <div class="show-work-step show-work-step--top">
      <div class="show-work-icon show-work-icon--upload" aria-hidden="true">
        <img src="assets/images/new-landing/icon_upload.svg" alt="">
      </div>
      <h3 class="show-work-step-title">1. Upload &amp; Secure</h3>
      <p class="show-work-step-description">
        Drag your raw file to your private vault. It’s securely stored and never shared outside unless you choose to download it.
      </p>
      <p class="show-work-step-note">Supported Formats: FBX &amp; USDZ.</p>
    </div>

    <div class="show-work-media">
      <div class="image-container image-container--centered">
        <div class="desktop-view">
          <img class="monitor-frame" src="assets/images/new-landing/device-imac.svg" alt="monitor frame" />
          <video class="monitor-video video1" autoplay loop muted playsinline preload="auto">
            <source type="video/mp4" [src]="landingMediaBaseUrl + '/_landing/Drag&Drop_step_web_compressed.mp4'">
          </video>
        </div>
        <div class="phone-container phone-composition">
          <img class="phone-frame" src="assets/images/new-landing/device-phone.svg" alt="Phone">
          <video class="phone-media first-screen-phone-video" autoplay loop muted playsinline preload="auto">
            <source type="video/mp4" [src]="landingMediaBaseUrl + '/_landing/Drag&Drop_step_mob_compressed.mp4'">
          </video>
        </div>
      </div>
    </div>

    <div class="show-work-step show-work-step--bottom">
      <div class="show-work-icon show-work-icon--server" aria-hidden="true">
        <img src="assets/images/new-landing/icon_server.svg" alt="">
      </div>
      <h3 class="show-work-step-title">2. Process &amp; Protect</h3>
      <p class="show-work-step-description">
        Our engine converts your model into a secure, view-only video feed - not a downloadable file.
      </p>
    </div>
  </section>

  <section class="share-control-section">
    <div class="share-control-media" aria-hidden="true"></div>
    <div class="share-control-content">
      <div class="show-work-icon show-work-icon--share" aria-hidden="true">
        <img src="assets/images/new-landing/icon_share_lock.svg" alt="">
      </div>
      <h3 class="share-control-title">3. Share &amp; Control</h3>
      <p class="share-control-description">
        Send a view-only link for approval. Clients see the cinematic result, but your source asset remains yours.
      </p>
    </div>
  </section>

  <section class="classic-landing-video">
    <div class="classic-landing-video__inner">
      <video class="classic-landing-video__media" autoplay loop muted playsinline preload="auto">
        <source type="video/mp4" [src]="lowerVideoUrl">
      </video>
    </div>
  </section>

</section>

<!-- Mobile Splash Screen - only shown in mobile builds -->
<app-splash-screen
  *ngIf="isMobilePlatform && (isMobileSplashVisible$ | async)"
  [showSignInForm]="(mobileSplashConfig$ | async)?.showSignInForm || false"
  [progressBarValue]="0"
  (closeClicked)="authModalService.onSplashCloseClicked()"
  (signInAppleClicked)="authModalService.onSplashSignInAppleClicked()"
  (signInGoogleClicked)="authModalService.onSplashSignInGoogleClicked()"
  [@fullscreenPanelAnimation]>
</app-splash-screen>
